<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
// import { kilobytes } from '@/utils/formatter';
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    // BEGIN::Removed.by.KWShin.2025.11.29.
    // title: String,
    // storeName: {
    //   type: String,
    //   required: true,
    // },
    // FINISH::Removed.by.KWShin.2025.11.29.
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'digit',
      },
    };
  },
  computed: {
    // BEGIN::Added.by.KWShin.2025.11.29.
    title() {
      return this.$t('dv.title.os.disk');
    },
    isWs() {
      return this.descendants.find(d => d.active).supportWebService;
    },
    // FINISH::Added.by.KWShin.2025.11.29.
    // BEGIN::Removed.by.KWShin.2025.11.29.
    // descendants() {
    //   return this.$store.getters[`${this.storeName}/get`];
    // },
    // descendant() {
    //   return (this.descendants || []).find(d => d.active);
    // },
    // FINISH::Removed.by.KWShin.2025.11.29.
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  methods: {
    setData(data) {
      // BEGIN:Modified.by.KWShin.2025.11.29.
      // if (this.descendant.supportWebService) this.data.value = kilobytes(data.reduce((acc, item) => (acc += parseFloat(item.tps)), 0).toFixed(2));
      // else this.data.value = parseInt(data.diskUtil);
      if (data.length > 0) {
        let sum = 0;
        data.forEach(datum => {
          if (this.isWs) {
            sum = sum + parseFloat(datum.tps || 0);
          } else {
            sum += parseInt(datum.diskUtil || 0);
          }
        });
        this.data.value = Math.ceil(sum / data.length);
      } else {
        this.data.value = '0';
      }
      // FINISH:Modified.by.KWShin.2025.11.29.
    },
  },
};
</script>
